<h2 mat-dialog-title>
    {{title}}
</h2>

<mat-dialog-content style="padding: 10px;">
    <ng-container *ngIf="!isSaving; else busy">
        <ng-container *ngIf="success; else error">
            <div>{{successMessage}}</div>
        </ng-container>
    </ng-container>
</mat-dialog-content>

<mat-dialog-actions>
    <button *ngIf="!isSaving" mat-button color="primary" (click)="close()" telemetry="Submission-SaveDialogOK">
        OK
    </button>
</mat-dialog-actions>

<ng-template #busy>
    <busy-indicator></busy-indicator>
</ng-template>

<ng-template #error>
    <div>{{errorMessage}}</div>
    <br>
    <br>
    <div>{{errors}}</div>
</ng-template>